<template>
  <div @click="clickHandler" style="cursor: pointer; text-align: left;">
    <v-btn
      fab
      x-small
      :text="!selected"
      :color="color"
      :dark="selected"

      class="mr-2"
    >
      <v-icon
        large
        x-small
      >
        {{ icon }}
      </v-icon>
    </v-btn>
    {{ labelText }}
  </div>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormBoolean',

  props: {
    ...formElementProps
  },

  computed: {
    ...sharedComputed,

    selected () {
      return this.field && this.value[this.field.fieldName]
    },

    color () {
      return this.selected
        ? this.field.info.listTrueColor || '#9E9E9E'
        : '#BDBDBD'
    },

    icon () {
      return this.value[this.field.fieldName]
        ? this.field.info.listIconForTrue || this.field.info.listIcon || 'fa-check'
        : this.field.info.listIconForFalse || this.field.info.listIcon || 'fa-check'
    }
  },

  methods: {
    ...sharedMethods,

    clickHandler () {
      if (this.field.canEdit) {
        this.value[this.field.fieldName] = !this.value[this.field.fieldName]
      }
    }
  }
}
</script>
